import { StatusTag } from '@zennolab_platform/webui-kit/dist/ui';
import styled from 'styled-components';

/** The kit StatusTag (outlined, kit radius and padding) at the PxM/PfM size: 13px text, 26px high, content
 * centred on one line. `&&` outranks the kit Tag's own 14px font size; `$fontSize` would not reach it
 * through `styled()`. */
export const KitTag = styled(StatusTag)`
  && {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    height: 26px;
    margin-inline-end: 0;
    font-size: 13px;
    white-space: nowrap;
  }
`;
